import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { MainComponent } from './layout/main/main.component';

export const routes: Routes = [
    { path: "", redirectTo: "/main/listarCartera", pathMatch: "full" },
    {
        path:"main",
        component:MainComponent,
        children:[
            {
                path: "listarCartera",
                loadChildren: () =>
                import('./modules/cartera/cartera.module').then(
                    (m) => m.CarteraModule
                ),
            },
            {
                path: "cartera",
                loadChildren: () =>
                import('./modules/form-cartera/form-cartera.module').then(
                    (m) => m.FormCarteraModule
                ),
            }

        ]
    }

];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'});
